import { IItemData } from '../fetchRentLicenses'

export default async function(response: Response) {
  let json = await response.json()

  const value = json.items[0]

  return value.map((item: IItemData) => ({
    license: item.license_str,
    rooms: item.rooms,
    selection_type: item.selection_type,
    id: item.id,
  }))
}
